export var buildInitialState = function () { return ({
    visibleBanner: null,
    dismissedBanners: [],
    handlers: {},
}); };
